module.exports = __webpack_public_path__ + "img/甘肃交通广播_03.6b7ac17a.jpg";